import { monthlyHot } from "@/mocks/comics";
import SectionHeader from "./SectionHeader";

const RANK = ["冠军", "亚军", "季军", "殿军"];

export default function MonthlyHot() {
  return (
    <section id="本月热荐" className="bg-foreground-900">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="本月热荐"
          eyebrowTone="secondary"
          title={
            <>
              <span className="text-background-50">本月热荐榜单</span>
              <span className="text-secondary-400"> · 大家都在看</span>
            </>
          }
          subtitle="根据书友热度与编辑部口碑综合排出的月度榜单，追更不迷路，冲就对了。"
        />

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {monthlyHot.map((comic, index) => (
            <article
              key={comic.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-700 bg-foreground-800 transition-colors hover:border-secondary-500"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-foreground-700">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 本月热荐排名漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-secondary-500 px-2.5 py-1 text-xs font-black text-background-50">
                  <i className="ri-trophy-line" aria-hidden="true"></i>
                  {RANK[index]}
                </span>
              </div>
              <div className="flex flex-1 flex-col gap-2 p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-base font-bold text-background-50">{comic.title}</h3>
                  <span className="font-heading text-3xl font-black text-secondary-400">0{index + 1}</span>
                </div>
                <p className="text-xs text-background-300">{comic.genre} · {comic.author}</p>
                <p className="text-xs leading-relaxed text-background-200">{comic.summary}</p>
                <div className="mt-auto flex flex-wrap gap-1.5 pt-2">
                  {comic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md bg-foreground-700 px-2 py-0.5 text-xs text-background-100"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}